export default [
  {
    name: 'mySelf',//个人中心
    path: '/mySelf',
    meta: {
      title: '个人中心',
      showTab: true,
      goHome: true,
    },
    component: () => import("@/pages/mySelf/mySelf.vue"),
  },
  {
    name: 'myEnroll',//我的报名
    path: '/myEnroll',
    meta: {
      title: '我的报名',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/myEnroll.vue"),
  },
  {
    name: 'enrollDetail',//报名详情
    path: '/enrollDetail',
    meta: {
      title: '报名详情',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/enrollDetail.vue"),
  },
  {
    name: 'myselfInfo',//个人信息
    path: '/myselfInfo',
    meta: {
      title: '个人信息',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/myselfInfo.vue"),
  },
  {
    name: 'telEdit',//修改手机号
    path: '/telEdit',
    meta: {
      title: '修改手机号',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/telEdit.vue"),
  },
  {
    name: 'blackPass',//修改密码
    path: '/blackPass',
    meta: {
      title: '修改密码',
      showTab: false,
      goHome: true,
    },
    component: () => import("@/pages/mySelf/blackPass.vue"),
  },
  {
    name: 'passSuccess',// 修改密码成功
    path: '/passSuccess',
    meta: {
      title: '修改密码成功',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/passSuccess.vue"),
  },
  {
    name: 'publicity',// 成绩公示
    path: '/publicity',
    meta: {
      title: '成绩查询',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/publicity.vue"),
  },
  {
    name: 'publicityGo',// 成绩公示
    path: '/publicityGo',
    meta: {
      title: '成绩查询',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/publicityGo.vue"),
  },
  {
    name: 'historyScore',//历史成绩
    path: '/historyScore',
    meta: {
      title: '历史成绩',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/historyScore.vue"),
  },
  {
    name: 'examinationRoom',//考场查询
    path: '/examination/room',
    meta: {
      title: '考场查询',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/examinationRoom.vue"),
  },
  {
    name: 'examinationRoomDetails',//考场查询-详情
    path: '/examination/room/details',
    meta: {
      title: '考场查询-详情',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/roomInfo.vue"),
  },
  {
    name: 'realAuthen',//实名认证
    path: '/realAuthen',
    meta: {
      title: '实名认证',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/realAuthen.vue"),
  },
  {
    name: 'realCard',//上传实名证件
    path: '/realCard',
    meta: {
      title: '上传证件',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/realCard.vue"),
  },
  {
    name: 'realSuccess',//认证成功
    path: '/realSuccess',
    meta: {
      title: '认证成功',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/realSuccess.vue"),
  },
  {
    name:'gradeDetail',//成绩详情
    path: '/gradeDetail',
    meta: {
      title: '成绩详情',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/gradeDetail.vue"),
  },
  {
    name:'reviewRel',//复核结果
    path: '/reviewRel',
    meta: {
      title: '复核结果',
      showTab: false,
    },
    component: () => import("@/pages/mySelf/reviewRel.vue"),
  },
]